export default __webpack_public_path__ + "static/media/Logo.d49d0b0a.svg";